/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from "underscore";

import Api from "base/api";
import { createSource } from "@evertrue/et-flux";
import Navigator from "utils/navigator";
import ErrorLogger from "utils/error-logger";
import { AlertActions } from "@evertrue/et-components";

export default createSource("LidsSource", {
  actions: {
    fetchedLinkedinAssociation(user) {
      return this.require(_.isObject(user), "user should be object");
    },
    destroyedLinkedinAssociation: true,
    completedAssociation(token) {
      return this.require(_.isString(token), "token should be string");
    },
  },

  api: {
    fetchLinkedinAssociation() {
      return Api.LIDS.ASSOCIATE.get({
        preventLogging: true,
        success: user => {
          if (user) {
            return this.actions.fetchedLinkedinAssociation(user);
          }
        },
        error(xhr) {
          // This is expected to fail if they haven't connected their LI account
          if (xhr.status !== 412) {
            ErrorLogger.captureRequest("fetchedLinkedinAssociation", xhr);
          }
        },
      });
    },

    destroyLinkedinAssociation() {
      Api.LIDS.ASSOCIATE.delete({
        success: () => {
          this.actions.destroyedLinkedinAssociation();
          AlertActions.launchToast({
            message: "Succesfully disconnected your LinkedIn account.",
            type: "success",
          });
        },
        error(xhr) {
          ErrorLogger.captureRequest("destroyLinkedinAssociation", xhr);
        },
      });
    },

    createLinkedinAssociation() {
      Api.LIDS.AUTH_URL.get({
        params: {
          callback_url: window.location.origin + "/auth/linkedin/connect",
        },
        success(resp) {
          window.location = resp.authorize_url;
        },
        error(xhr) {
          ErrorLogger.captureRequest("createLinkedinAssociation", xhr);
        },
      });
    },

    linkedInCallback(query) {
      Api.LIDS.ACCESS_TOKEN.get({
        params: query,
        success: resp => {
          this.linkedInAssociation(resp.linkedin_access_token);
        },
        error(xhr) {
          ErrorLogger.captureRequest("linkedInCallback", xhr);
          Navigator.goToInitialRoute();
        },
      });
    },

    linkedInAssociation(access_token) {
      Api.LIDS.ASSOCIATE.put({
        params: {
          linkedin_access_token: access_token,
        },
        success: () => {
          this.actions.completedAssociation(access_token);
        },
        error(xhr) {
          ErrorLogger.captureRequest("linkedInAssociation", xhr);
          Navigator.goToInitialRoute();
        },
      });
    },
  },
});
